// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3n34Y","error":"Textarea_error__2fhJR","readonly":"Textarea_readonly__20mEq","disabled":"Textarea_disabled__3OSOp"};